<template>
  <div class="form-white-bg">
    <div class="w-100">
      <b-button v-b-toggle:my-collapse class="toggle_button mb-3 float-right">
        <span class="when-open">Close</span
        ><span class="when-closed">Open</span> Details
      </b-button>
      <b-collapse visible id="my-collapse">
        <b-row class="p-3" v-if="loading">
          <b-col lg="8" md="8">
            <div class="asset-stats-card">
              <Skeleton height="1.5rem" width="100%" class="mb-4"></Skeleton>
              <div class="d-flex justify-content-around">
                <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
                <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
                <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
                <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
              </div>
            </div>
          </b-col>
          <b-col lg="4" md="4">
            <div class="details-card">
              <Skeleton height="1.5rem" width="100%" class="mb-5"></Skeleton>
              <b-row>
                <b-col lg="6" md="6" v-for="item in 4">
                  <div class="quickcreatecard p-0">
                    <Skeleton
                      height="5rem"
                      width="100%"
                      class="mb-2"
                    ></Skeleton>
                    <Skeleton
                      height="2rem"
                      width="100%"
                      class="mb-5"
                    ></Skeleton>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col lg="8" md="8" sm="12" cols="12">
            <div class="asset-stats-card" v-if="loading">
              <Skeleton height="2rem" width="100%" class="mb-2"></Skeleton>
              <div class="d-flex justify-content-around">
                <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
                <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
                <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
                <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
              </div>
            </div>
            <div class="asset-stats-card" v-if="!loading">
              <h6 class="stats-title">
                {{ t("assetManagement.Deployment.assetstats") }}
              </h6>
              <div class="stats-grid">
                <div class="stat-item">
                  <i class="pi pi-box"></i>
                  <span class="stat-label"
                    >{{ t("assetManagement.Deployment.totalassets") }}:</span
                  >
                  <span class="stat-value total">
                    {{ DetailsData.TotalAsset }}</span
                  >
                </div>
                <div class="stat-item">
                  <i class="pi pi-check-circle"></i>
                  <span class="stat-label"
                    >{{ t("assetManagement.Deployment.assigned") }}:</span
                  >
                  <span class="stat-value assigned">{{
                    DetailsData.Assigned
                  }}</span>
                </div>
                <div class="stat-item">
                  <i class="pi pi-question-circle"></i>
                  <span class="stat-label"
                    >{{ t("assetManagement.Deployment.unassigned") }}:</span
                  >
                  <span class="stat-value unassigned">{{
                    DetailsData.UnAssigned
                  }}</span>
                </div>
                <!-- <div class="stat-item">
                  <i class="pi pi-desktop"></i>
                  <span class="stat-label"
                    >{{ t("assetManagement.Deployment.inuse") }}:</span
                  >
                  <span class="stat-value in-use">{{
                    DetailsData.AssetInUse
                  }}</span>
                </div> -->
              </div>
            </div>
          </b-col>
          <b-col lg="4" md="4" sm="12" cols="12">
            <div class="carddetails">
              <h6 class="ps-3 pt-2">Quick Access</h6>
              <div>
                <!-- <div class="individualcard">
                                    <div class="individualimg">
                                        <img src="/src/assets/Img/notification.svg">
                                    </div>
                                    <p class="quickcardheader">{{ t('assetManagement.Deployment.reviewassetrequest') }}
                                    </p>
                                </div> -->
                <!-- <div class="individualcard" @click="viewAllAssets">
                                    <div class="individualimg">
                                        <img src="/src/assets/Img/notification.svg">
                                    </div>
                                    <p class="quickcardheader">{{
                                        t('assetManagement.Deployment.viewallasset') }}</p>
                                </div> -->
                <div class="individualcard" @click="assignNewAsset()">
                  <div class="individualimg">
                    <img
                      src="../../../../../../../assets/Img/notification.svg"
                    />
                  </div>
                  <p class="quickcardheader">
                    {{ t("assetManagement.Deployment.assignnewasset") }}
                  </p>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <b-row>
      <b-col lg="12">
        <!-- {{ items }} -->
        <SkeletonTableLoader :columns="headers" :loading="loading" />
        <div v-if="!loading">
          <MasterEmpty
            v-if="items.length == 0"
            :eheader="t('assetManagement.Deployment.deploymenttable')"
            :econtent="t('assetManagement.Deployment.deploymenttable')"
            eimg="/src/assets/Img/icons/itemmaster.svg"
            @createNew="assignNewAsset"
            class="mt-3"
          />
          <Tableview
            v-if="items.length !== 0"
            :value="items"
            :paginator="false"
            class="p-datatable-gridlines"
            :rows="state.pageSize"
            dataKey="Id"
            :rowHover="true"
            filterDisplay="menu"
            :loading="loading"
            responsiveLayout="scroll"
            :columns="headers"
            :globalFilterFields="globalFilterFields"
            :filters="filters"
            :totalRecords="rowsCount"
            :state="state"
          >
            <!-- <template v-slot:Status="{ data }">
              <GreyStatus name="UnderMaintenance" v-if="data.Status == 2" />
              <RedStatus name="Disposed" v-if="data.Status == 3" />
              <OrangeStatus name="Pending" v-if="data.Status == 4" />
              <GreenStatus name="Active" v-if="data.Status == 1" />
            </template> -->
            <template v-slot:action="{ data }">
              <!-- <Button :label="t('assetManagement.Deployment.assign')" class="p-button-sm"
                                @click="manageAsset(data)" /> -->
              <Button
                icon="pi pi-ellipsis-v"
                class="p-button-rounded editicon p-button-text"
                @click="toggle($event, data)"
              />
            </template>
          </Tableview>
        </div>
      </b-col>
    </b-row>
  </div>

  <Menu ref="menu" id="overlay_menu" :model="itemList" :popup="true" />
</template>

<script lang="ts">
import { defineComponent, ref, reactive, computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useToast } from "primevue/usetoast";
import { FilterMatchMode } from "primevue/api";
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MasterEmpty from "../../../../../../../components/Masters/MasterEmpty.vue";
import { useRouter, useRoute } from "vue-router";
import AssetAssignmentService from "../../../../../../../modules/Inventory/Service/AssetManagement/AssetAssignmentService";

export default defineComponent({
  components: {
    Tableview,
    SkeletonTableLoader,
    MasterEmpty,
  },
  setup() {
    const { t } = useI18n();
    const toast = useToast();
    let objectdata = ref({});
    const router = useRouter();
    const routes = useRoute();
    const menu = ref();
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    let HospitalId = Number(usersData.OrganizationId);
    const ParamValues = ref({
      StoreId: Number(routes.query.Id ?? 0),
      BranchId: Number(routes.query.BranchId ?? 0),
    });
    const toggle = (event, data) => {
      objectdata = data;
      menu.value.toggle(event);
    };
    const itemList = ref([
      {
        items: [
          {
            label: "Asset Assign",
            icon: "pi pi-directions",
            visible: true,
            command: async () => {
              assignNewAsset();
            },
          },
        ],
      },
    ]);
    const state = reactive({
      currentPage: 1,
      pageSize: 10,
      totalRows: 0,
    });

    const items: any = ref([]);
    const DetailsData: any = ref([]);
    const loading = ref(false);
    const rowsCount = ref(0);
    const filtervisible = ref(false);
    const pendingRequestsCount = ref(3);

    const headers = [
      {
        header: t("assetManagement.assetassign.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("assetManagement.assetassign.name"),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.assetassign.assignTo"),
        field: "AssignTo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.assetassign.location"),
        field: "Location",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("assetManagement.assetassign.status"),
        field: "Status",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        // fieldDisplay: "false",
        // slot: "Status",
      },
      // {
      //     header: t('assetManagement.assetassign.action'),
      //     field: "action",
      //     slot: 'action',
      //     fieldDisplay: "false",
      //     filterTemplate: "MultiSelect",
      //     ShowMactchMode: false,
      // },
    ];

    const globalFilterFields = computed(() => headers.map((col) => col.field));

    const filters = reactive({
      global: {
        value: null,
        matchMode: FilterMatchMode.CONTAINS,
        options: items,
      },
      Name: {
        value: null,
        matchMode: FilterMatchMode.STARTS_WITH,
        options: items,
      },
      AssignTo: {
        value: null,
        matchMode: FilterMatchMode.STARTS_WITH,
        options: items,
      },
      Location: {
        value: null,
        matchMode: FilterMatchMode.STARTS_WITH,
        options: items,
      },
      Status: {
        value: null,
        matchMode: FilterMatchMode.STARTS_WITH,
        options: items,
      },
    });

    const SearchValue = ref({
      inputValue: "",
      fromDate: "",
      toDate: "",
    });

    onMounted(async () => {
      await IsShow();
    });
    async function IsShow() {
      debugger;
      debugger;
      try {
        loading.value = true;
        let count = 0;
        const dataresponse = await AssetAssignmentService.getDashboarddata(
          HospitalId,
          ParamValues.value.BranchId,
          ParamValues.value.StoreId
        );
        DetailsData.value = dataresponse["result"];
        items.value = dataresponse["result"]["AssignmentList"].map(
          (item: any) => {
            count = count + 1;
            item.RowNumber = count;
            return item;
          }
        );
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    const SearchBox = (value) => {
      SearchValue.value.inputValue = value;
      // Implement search logic here
    };

    const toggleFilter = () => {
      filtervisible.value = !filtervisible.value;
    };

    const reviewAssetRequests = () => {
      // Implement review asset requests logic
    };
    const viewAllAssets = () => {
      // Implement view all assets logic
    };
    const assignNewAsset = () => {
      router.push({
        path: "/AssignAsset",
        query: {
          Assign: "WithoutRequest",
          data: JSON.stringify(ParamValues.value),
        },
      });
    };

    return {
      t,
      state,
      items,
      loading,
      rowsCount,
      filtervisible,
      pendingRequestsCount,
      headers,
      globalFilterFields,
      filters,
      SearchValue,
      SearchBox,
      toggleFilter,
      reviewAssetRequests,
      assignNewAsset,
      viewAllAssets,
      toggle,
      itemList,
      menu,
      ParamValues,
      DetailsData,
      usersData,
      rolesData,
      EntityData,
      HospitalId,
    };
  },
});
</script>

<style scoped>
.status-inuse {
  color: green;
}

.status-available {
  color: blue;
}

.status-maintenance {
  color: orange;
}
</style>
